export const Constants = {
  adjustment: 'Ajustes',
  residence: 'Residencial',
  house: 'Casa',
  flat: 'Apartamento',
  comerce: 'Comercial',
  freeFloor: 'Andar livre',
  store: 'Salas e lojas',
  warehouse: 'Galpão',
  industry: 'Industrial',
  cub: 'CUB transformado',
  rstandard: 'R-Padrão',
  logic: 'Lógica',
  popular: 'Popular',
  simple: 'Simples',
  normal: 'Normal',
  high: 'Alto',
  luxe: 'Luxo',
  tableInfo:
    '***O termo CUB representa o valor indicado em R-Padrão e é obrigatório na lógica',
  confirm: 'confirmar alterações',
};

type StandardKey = 'simple' | 'normal' | 'high';

export type Standards = Record<StandardKey, string>;

export const ApartmentStandards: Standards = {
  simple: 'CUB: R-8 Baixo',
  normal: 'CUB: R-8 Normal',
  high: 'CUB: R-16 Alto',
};

export const StoreStandards: Standards = {
  simple: 'CUB: CSL-8 Normal',
  normal: 'CUB: CAL-8 Alto',
  high: 'CUB: CSL-16 Alto',
};

export const WarehouseStandards: Standards = {
  simple: 'CUB: R-8 Normal',
  normal: 'CUB: R-8 Normal',
  high: 'CUB: R-8 Normal',
};
